import { useState } from 'react';
import { API_ENDPOINTS } from '../../config/api';

const Contact = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: 'İletişim Formu Mesajı',
        message: ''
    });
    const [status, setStatus] = useState({
        message: '',
        type: ''
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus({ message: '', type: '' });

        try {
            const response = await fetch(API_ENDPOINTS.contact.send(), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            });

            const data = await response.json();

            if (response.ok) {
                setStatus({
                    message: 'Mesajınız başarıyla gönderildi. En kısa sürede size dönüş yapacağız.',
                    type: 'success'
                });
                setFormData({
                    name: '',
                    email: '',
                    subject: 'İletişim Formu Mesajı',
                    message: ''
                });
            } else {
                setStatus({
                    message: data.message || 'Mesaj gönderilirken bir hata oluştu.',
                    type: 'error'
                });
            }
        } catch (error) {
            console.error('Mesaj gönderilirken bir hata oluştu:', error);
            setStatus({
                message: 'Mesaj gönderilirken bir hata oluştu.',
                type: 'error'
            });
        }
    };

    return (
        <div className="contact-us section" id="contact">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 align-self-center">
                        <div className="section-heading">
                            <h6>Bize Ulaşın</h6>
                            <h2>Sorularınız mı var? Hemen iletişime geçin</h2>
                            <p>ANISAKLA hakkında daha fazla bilgi almak, önerilerinizi iletmek veya teknik destek almak için bize ulaşın. En kısa sürede size dönüş yapacağız.</p>
                            <div className="special-offer">
                                <span className="offer">indirim<br /><em>%25</em></span>
                                <h6>Geçerlilik: <em>31 Aralık 2025</em></h6>
                                <h4>Özel Teklif <em>%25</em> İndirim!</h4>
                                <a href="#"><i className="fa fa-angle-right"></i></a>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="contact-us-content">
                            {status.message && (
                                <div className={`alert ${status.type === 'success' ? 'alert-success' : 'alert-danger'}`}>
                                    {status.message}
                                </div>
                            )}
                            <form id="contact-form" onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="col-lg-12">
                                        <fieldset>
                                            <input
                                                type="text"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleChange}
                                                placeholder="Adınız Soyadınız..."
                                                required
                                            />
                                        </fieldset>
                                    </div>
                                    <div className="col-lg-12">
                                        <fieldset>
                                            <input
                                                type="email"
                                                name="email"
                                                value={formData.email}
                                                onChange={handleChange}
                                                placeholder="E-posta Adresiniz..."
                                                required
                                            />
                                        </fieldset>
                                    </div>
                                    <div className="col-lg-12">
                                        <fieldset>
                                            <textarea
                                                name="message"
                                                value={formData.message}
                                                onChange={handleChange}
                                                placeholder="Mesajınız"
                                                required
                                            ></textarea>
                                        </fieldset>
                                    </div>
                                    <div className="col-lg-12">
                                        <fieldset>
                                            <button type="submit" className="orange-button">Mesaj Gönder</button>
                                        </fieldset>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contact;
